import {
  LIST_BRANCH_CONDITIONAL_HOUR_REQUEST,
  LIST_BRANCH_CONDITIONAL_HOUR_SUCCESS,
  LIST_BRANCH_CONDITIONAL_HOUR_FAIL,
  CREATE_BRANCH_DATE_CONDITIONAL_HOUR_REQUEST,
  CREATE_BRANCH_DATE_CONDITIONAL_HOUR_SUCCESS,
  CREATE_BRANCH_DATE_CONDITIONAL_HOUR_FAIL,
  DETAIL_BRANCH_DATE_CONDITIONAL_HOUR_REQUEST,
  DETAIL_BRANCH_DATE_CONDITIONAL_HOUR_SUCCESS,
  DETAIL_BRANCH_DATE_CONDITIONAL_HOUR_FAIL,
  CREATE_BRANCH_HOUR_CONDTIONAL_HOUR_REQUEST,
  CREATE_BRANCH_HOUR_CONDTIONAL_HOUR_SUCCESS,
  CREATE_BRANCH_HOUR_CONDTIONAL_HOUR_FAIL,
  DETAIL_BRANCH_HOUR_CONDTIONAL_HOUR_REQUEST,
  DETAIL_BRANCH_HOUR_CONDTIONAL_HOUR_SUCCESS,
  DETAIL_BRANCH_HOUR_CONDTIONAL_HOUR_FAIL,
  UPDATE_BRANCH_DATE_CONDITIONAL_HOUR_REQUEST,
  UPDATE_BRANCH_DATE_CONDITIONAL_HOUR_SUCCESS,
  UPDATE_BRANCH_DATE_CONDITIONAL_HOUR_FAIL,
  UPDATE_BRANCH_HOUR_CONDTIONAL_HOUR_REQUEST,
  UPDATE_BRANCH_HOUR_CONDTIONAL_HOUR_SUCCESS,
  UPDATE_BRANCH_HOUR_CONDTIONAL_HOUR_FAIL,
  DELETE_BRANCH_DATE_CONDITIONAL_HOUR_REQUEST,
  DELETE_BRANCH_DATE_CONDITIONAL_HOUR_SUCCESS,
  DELETE_BRANCH_DATE_CONDITIONAL_HOUR_FAIL,
  DELETE_BRANCH_HOUR_CONDTIONAL_HOUR_REQUEST,
  DELETE_BRANCH_HOUR_CONDTIONAL_HOUR_SUCCESS,
  DELETE_BRANCH_HOUR_CONDTIONAL_HOUR_FAIL,
  LIST_BRANCH_CONDITIONAL_HOUR_RESET
} from '../../../constants/branches/conditional-hours'

const initialState = {
  loading: false,
  error: null,
  conditionalHours: [],
  conditionalHour: {}
}

const conditionalHoursReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_BRANCH_CONDITIONAL_HOUR_REQUEST:
      return { ...state, loading: true }
    case LIST_BRANCH_CONDITIONAL_HOUR_SUCCESS:
      return { ...state, loading: false, conditionalHours: action.payload }
    case LIST_BRANCH_CONDITIONAL_HOUR_FAIL:
      return { ...state, loading: false, error: action.payload }
    case DETAIL_BRANCH_DATE_CONDITIONAL_HOUR_REQUEST:
      return { ...state, loadingDetail: true }
    case DETAIL_BRANCH_DATE_CONDITIONAL_HOUR_SUCCESS:
      return { ...state, loadingDetail: false, conditionalHourDate: action.payload }
    case DETAIL_BRANCH_DATE_CONDITIONAL_HOUR_FAIL:
      return { ...state, loadingDetail: false, error: action.payload }
    case LIST_BRANCH_CONDITIONAL_HOUR_RESET:
      return { ...state, loading: false, error: null, conditionalHours: [] }
    case CREATE_BRANCH_DATE_CONDITIONAL_HOUR_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_BRANCH_DATE_CONDITIONAL_HOUR_SUCCESS:
      return { ...state, loadingCreate: false }
    case CREATE_BRANCH_DATE_CONDITIONAL_HOUR_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case UPDATE_BRANCH_DATE_CONDITIONAL_HOUR_REQUEST:
      return { ...state, loadingUpdate: true }
    case UPDATE_BRANCH_DATE_CONDITIONAL_HOUR_SUCCESS:
      return { ...state, loadingUpdate: false }
    case UPDATE_BRANCH_DATE_CONDITIONAL_HOUR_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case DELETE_BRANCH_DATE_CONDITIONAL_HOUR_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_BRANCH_DATE_CONDITIONAL_HOUR_SUCCESS:
      return { ...state, loadingDelete: false }
    case DELETE_BRANCH_DATE_CONDITIONAL_HOUR_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case CREATE_BRANCH_HOUR_CONDTIONAL_HOUR_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_BRANCH_HOUR_CONDTIONAL_HOUR_SUCCESS:
      return { ...state, loadingCreate: false }
    case CREATE_BRANCH_HOUR_CONDTIONAL_HOUR_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DETAIL_BRANCH_HOUR_CONDTIONAL_HOUR_REQUEST:
      return { ...state, loadingDetail: true }
    case DETAIL_BRANCH_HOUR_CONDTIONAL_HOUR_SUCCESS:
      return { ...state, loadingDetail: false, conditionalHourDateHour: action.payload }
    case DETAIL_BRANCH_HOUR_CONDTIONAL_HOUR_FAIL:
      return { ...state, loadingDetail: false, error: action.payload }
    case UPDATE_BRANCH_HOUR_CONDTIONAL_HOUR_REQUEST:
      return { ...state, loadingUpdate: true }
    case UPDATE_BRANCH_HOUR_CONDTIONAL_HOUR_SUCCESS:
      return { ...state, loadingUpdate: false }
    case UPDATE_BRANCH_HOUR_CONDTIONAL_HOUR_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case DELETE_BRANCH_HOUR_CONDTIONAL_HOUR_REQUEST:
      return { ...state, loadingHourDelete: true }
    case DELETE_BRANCH_HOUR_CONDTIONAL_HOUR_SUCCESS:
      return { ...state, loadingHourDelete: false }
    case DELETE_BRANCH_HOUR_CONDTIONAL_HOUR_FAIL:
      return { ...state, loadingHourDelete: false, error: action.payload }
    default:
      return state
  }
}

export default conditionalHoursReducer

